import { combineReducers } from "redux";
import authReducer from './auth/reducer'
import userReducer from './user/reducer'
import transactionReducer from './transactions/reducer'
import complaintReducer from './complaints/reducer'
import simplReducer from './simpl/reducer'
import chpReducer from './customer_payment_history/reducer'
import CustomerParameterReducer from './customer_parameters/reducer'
import serviceReducer from "./service/reducer";
import incentiveReducer from "./incentive/reducer";
import clientReducer from "./client_credential/reducer";
import communicationReducer from "./communication_channel/reducer"
import indicoreReducer from "./indicore/reducer";
import categoryReducer from "./categories/reducer";

const rootReducer = combineReducers({
    authReducer,
    userReducer,
    transactionReducer,
    complaintReducer,
    simplReducer,
    chpReducer,
    CustomerParameterReducer,
    serviceReducer,
    incentiveReducer,
    clientReducer,
    communicationReducer,
    indicoreReducer,
    categoryReducer
});
export default rootReducer;